import React, { useEffect, useState } from "react";
import {
  Tab,
  TabPane,
} from "semantic-ui-react";
import iconEnergia from "../../../../assets/svg/Capa 4.svg";
import iconCombustibles from "../../../../assets/svg/Capa 5.svg";
import iconAgua from "../../../../assets/svg/Capa 6.svg";
import iconEfluentes from "../../../../assets/svg/Rectangle 184.svg";
import iconResiduos from "../../../../assets/svg/Group.svg";
import iconSocial from "../../../../assets/svg/Capa 1.svg";
import iconGEI from "../../../../assets/svg/GroupGei.svg";
import { Line, Pie, Column } from "@ant-design/charts";
import { Link, useLocation } from "react-router-dom";
import { Permission, /* Productionform, Socialform */ } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./Dashboard.scss";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { WaterKPIsDashBoard } from "../WaterKPIsDashboard/WaterKPIsDashBoard";
import { useSite, useZoom, useDashTab } from "../../../../contexts";
import { EnergyKPIsDashBoard } from "../EnergyKPIsDashboard";
import { WasteKPIsDashBoard } from "../WasteKPIsDashboard";
//import { ObjectivesAndBaseline } from "../ObjectivesAndBaseline/ObjectivesAndBaseline";
import { EffluentKPIsDashBoard } from "../EffluentKPIsDashboard";
import { AirEmissionsKPIsDashBoard } from "../AirEmissionsKPIsDashboard/AirEmissionsKPIsDashBoard";
import { SocialKPIsDashBoard } from "../SocialKPIsDashboard";
import { FuelsKPIsDashBoard } from "../FuelsKPIsDashboard/FuelsKPIsDashBoard";
import { useCompany } from "../../../../contexts/CompanyContext";
import { EmissionsSummaryDashboard } from "../EmissionsSummaryDashboard/EmissionsSummaryDashBoard";

import { GEIDashBoard } from "../GEIDashboard/GEIDashBoard";
import { LegalRequirementsDashboard } from "../../LegalRequirements";
import { AnnualPlanDashboard } from "../../AnnualPlan";
import { AccidentsDashboard } from "../../Accidents";
import { ActionPlanDashboard } from "../../ActionPlans/ActionPlanDashboard";
import { CapacitacionesDashboard } from "../../Capacitaciones/CapacitacionesDashboard/CapacitacionesDashboard";
import { WorkPermitsDashboard } from "../../WorkPermits/WorkPermitsDashboard/WorkPermitsDashboard";
import { ChecklistDashboard } from "../../Checklist/ChecklistDashboard/ChecklistDashboard";
import { RiskAssessmentsDashboard } from "../../RiskAssessments";
import { GeneralDashboard } from "../GeneralDashboard/GeneralDashboard";
import { Company, Site } from "../../../../api";

const permissionController = new Permission();
const companyController    = new Company();
const siteController       = new Site();
// const productionController = new Productionform();
// const socialController = new Socialform();

export function DashBoard(props) {
  const { siteSelected, companySelected } = props;

  const { pathname } = useLocation();
  const {
    user: { role, site },
    accessToken,
  } = useAuth();

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [permissionActive, setPermissionsActive] = useState([]);
  const [sharedProductionForms, setSharedProductionForms] = useState(null);
  const [sharedWorkersByPeriod, setSharedWorkersByPeriod] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [siteName, setSiteName] = useState("");
  const { zoom } = useZoom();
  const { activeTab, setActiveTab } = useDashTab();

  const currentSite = site ? site : siteSelected;

  // Fetch company name for the dashboards' header/PDF export title
  useEffect(() => {
    if (!companySelected || companySelected === "0") { setCompanyName(""); return; }
    companyController.getCompany(accessToken, companySelected)
      .then((res) => setCompanyName(res?.name || ""))
      .catch(() => setCompanyName(""));
  }, [companySelected, accessToken]);

  // Fetch site name for the dashboards' header/PDF export title
  useEffect(() => {
    if (!currentSite || currentSite === "0") { setSiteName(""); return; }
    siteController.getSite(accessToken, currentSite)
      .then((res) => setSiteName(res?.name || ""))
      .catch(() => setSiteName(""));
  }, [currentSite, accessToken]);

  // useEffect(() => { ... productionController / socialController (disabled) }, []);

  const isCurrentPath = (path) => {
    if (path === pathname) return true;
    return false;
  };

  useEffect(() => {
    (async () => {
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getPermissionsByRole(
            accessToken,
            role._id,
            true
          );
          setPermissionsActive(response);
        }
      } catch (error) {
        //console.error(error);
        setPermissionsActive([]);
      }
    })();
  }, [role]);
useEffect(() => {
 // console.log("Dashboard montado");
}, []);

const getAbbreviation = (key, t) => {
  const word = t(key);
  return word.slice(0, 2).toUpperCase();
};


  const panes = [
    // {
    //   menuItem: "Overview",
    //   render: () => (
    //     <TabPane attached={false}>
    //       {" "}
    //       <Grid columns={2} divided className="main-cointainer">
    //         <GridColumn textAlign="center">
    //           <div className="chart-container_chart_line">
    //             <Line {...config} />
    //           </div>
    //         </GridColumn>
    //         <GridColumn>
    //           <div className="chart-container_chart_column">
    //             <Column {...config3} />
    //           </div>
    //         </GridColumn>
    //       </Grid>
    //       <Grid columns={2} divided className="main-cointainer">
    //         <GridColumn>
    //           <div className="chart-container_chart_line">
    //             <Line {...config} />
    //           </div>
    //         </GridColumn>
    //         <GridColumn>
    //           <div className="chart-container_chart_column">
    //             <Column {...config3} />
    //           </div>
    //         </GridColumn>
    //       </Grid>
    //     </TabPane>
    //   ),
    // },
    // {
    //   menuItem: "Objetivos y Linea Base",
    //   render: () => (
    //     <TabPane attached={false}>
    //       <ObjectivesAndBaseline site={site ? site : siteSelected} />
    //     </TabPane>
    //   ),
    // },
    // {
    //   menuItem: {
    //   key: "energy",
    //   content: (
    //     <div className="tab-item">
    //       <img src={iconEnergia} alt="energia" className="tab-item__icon" />
    //       <span className="tab-item__label">{t("energy")}</span>
    //     </div>
    //   ),
    // },
    // render: () => (
    //   <Tab.Pane attached={false}>
    //     <EnergyKPIsDashBoard site={currentSite} sharedProductionForms={sharedProductionForms} sharedWorkersByPeriod={sharedWorkersByPeriod} />
    //   </Tab.Pane>
    // ),
    // },
    // {
      
    //   menuItem: {
    //   key: "fuels",
    //   content: (
    //     <div className="tab-item">
    //       <img src={iconCombustibles} alt="combustibles" className="tab-item__icon" />
    //       <span className="tab-item__label">{t("fuels")}</span>
    //     </div>
    //   ),
    // },
    //   render: () => (
    //     <TabPane attached={false}>
    //       <FuelsKPIsDashBoard site={currentSite} sharedProductionForms={sharedProductionForms} sharedWorkersByPeriod={sharedWorkersByPeriod} />
    //     </TabPane>
    //   ),
    // },
    // {
    //    menuItem: {
    //   key: "water",
    //   content: (
    //     <div className="tab-item">
    //       <img src={iconAgua} alt="agua" className="tab-item__icon" />
    //       <span className="tab-item__label">{t("water")}</span>
    //     </div>
    //   ),
    // },
    //   render: () => (
    //     <TabPane attached={false}>
    //       {/* <Column {...config3} /> */}
    //       <WaterKPIsDashBoard site={currentSite} sharedProductionForms={sharedProductionForms} />
    //     </TabPane>
    //   ),
    // },
    // {
    //   menuItem: {
    //   key: "effluent",
    //   content: (
    //     <div className="tab-item">
    //       <img src={iconEfluentes} alt="efluentes" className="tab-item__icon" />
    //       <span className="tab-item__label">{t("effluent")}</span>
    //     </div>
    //   ),
    // },
    //   render: () => (
    //     <TabPane attached={false}>
    //       <EffluentKPIsDashBoard site={currentSite} sharedProductionForms={sharedProductionForms} sharedWorkersByPeriod={sharedWorkersByPeriod} />
    //     </TabPane>
    //   ),
    // },
    // {
      
    //   menuItem: {
    //   key: "waste",
    //   content: (
    //     <div className="tab-item">
    //       <img src={iconResiduos} alt="residuos" className="tab-item__icon" />
    //       <span className="tab-item__label">{t("waste")}</span>
    //     </div>
    //   ),
    // },
    //   render: () => (
    //     <TabPane attached={false}>
    //       <WasteKPIsDashBoard site={currentSite} sharedProductionForms={sharedProductionForms} />
    //     </TabPane>
    //   ),
    // },
    // {
    //   menuItem: {
    //   key: "air",
    //   content: (
    //     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    //       <div
    //         style={{
    //           backgroundColor: "#05b4e0ff", // azul estilo Sustemia
    //           borderRadius: "50%",
    //           width: "28px",
    //           height: "28px",
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "center",
    //           color: "white",
    //           fontWeight: "bold",
    //           fontSize: "13px",
    //         }}
    //       >
    //         {getAbbreviation("air", t)}
    //       </div>
    //       <span>{t("air")}</span>
    //     </div>
    //   ),
    // },
    //   render: () => (
    //     <TabPane attached={false}>
    //       <AirEmissionsKPIsDashBoard site={site ? site : siteSelected} />
    //     </TabPane>
    //   ),
    // },
    //  {
    //   menuItem: {
    //   key: "social",
    //   content: (
    //     <div className="tab-item">
    //       <img src={iconSocial} alt="social" className="tab-item__icon" />
    //       <span className="tab-item__label">{t("social")}</span>
    //     </div>
    //   ),
    // },
    //    render: () => (
    //      <TabPane attached={false}>
    //        <SocialKPIsDashBoard site={currentSite} sharedProductionForms={sharedProductionForms} sharedWorkersByPeriod={sharedWorkersByPeriod} />
    //      </TabPane>
    //    ),
    // },  

    //    {
    //   menuItem: "Resumen Emisiones",
    //   render: () => (
    //     <TabPane attached={false}>
    //       <EmissionsSummaryDashboard site={site ? site : siteSelected} />
    //     </TabPane>
    //   ),
    // },
    //    {
    //    menuItem: {
    //   key: "gei",
    //   content: (
    //     <div className="tab-item">
    //       <img src={iconGEI} alt="GEI" className="tab-item__icon" />
    //       <span className="tab-item__label">{t("GEI")}</span>
    //     </div>
    //   ),
    // },
    //   render: () => (
    //     <TabPane attached={false}>
    //       <GEIDashBoard site={site ? site : siteSelected} />
    //     </TabPane>
    //   ),
    // },
    {
      menuItem: t("init"),
      render: () => (
        <TabPane attached={false}>
          <GeneralDashboard companyName={companyName} siteName={siteName} company={companySelected} siteSelected={siteSelected || null} />
        </TabPane>
      ),
    },
    // TEMP: solo se muestra Inicio por el momento
     {
       menuItem: t("requirements_title"),
       render: () => (
         <TabPane attached={false}>
           <LegalRequirementsDashboard companyName={companyName} siteName={siteName} />
         </TabPane>
       ),
     },
     {
       menuItem: t("annual_plan"),
       render: () => (
         <TabPane attached={false}>
           <AnnualPlanDashboard companyName={companyName} siteName={siteName} />
         </TabPane>
       ),
     },
     {
       menuItem: t("accident_management"),
       render: () => (
         <TabPane attached={false}>
           <AccidentsDashboard companyName={companyName} siteName={siteName} />
         </TabPane>
       ),
     },
     {
       menuItem: t("action_plan_management"),
       render: () => (
         <TabPane attached={false}>
           <ActionPlanDashboard reload={false} onReload={() => {}} companyName={companyName} siteName={siteName} />
         </TabPane>
       ),
     },
     //{
       //menuItem: t("training_management"),
       //render: () => (
        // <TabPane attached={false}>
          // <CapacitacionesDashboard site={siteSelected} />
         //</TabPane>
       //),
     //},
     {
       menuItem: t("work_permits"),
       render: () => (
         <TabPane attached={false}>
           <WorkPermitsDashboard site={siteSelected} companyName={companyName} siteName={siteName} />
         </TabPane>
       ),
     },
     {
      menuItem: t("checklist"),
      render: () => (
        <TabPane attached={false}>
          <ChecklistDashboard companyName={companyName} siteName={siteName} />
        </TabPane>
      ),
    },
    {
      menuItem: t("risk_assessments") || "Evaluación de Riesgos",
      render: () => (
        <TabPane attached={false}>
          <RiskAssessmentsDashboard companyName={companyName} siteName={siteName} />
        </TabPane>
      ),
    },

  ];
  

  const subPanes = [
    {
      menuItem: "Overview",
      render: () => (
        <TabPane attached={false}>
          {" "}
          <Grid columns={2}>
            <GridColumn>
              <Line {...config} />
            </GridColumn>
            <GridColumn>
              <Line {...config} />
            </GridColumn>
          </Grid>{" "}
        </TabPane>
      ),
    },
    {
      menuItem: "Energia",
      render: () => (
        <TabPane attached={false}>
          <Pie {...config2} />
        </TabPane>
      ),
    },
    {
      menuItem: "Combustible",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
    {
      menuItem: "Agua",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
    {
      menuItem: "Efluentes",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
    {
      menuItem: "Residuos",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
    {
      menuItem: "Peligrosos",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
    {
      menuItem: "Social",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
  ];

  const data = [
    { year: "1991", value: 3 },
    { year: "1992", value: 4 },
    { year: "1993", value: 3.5 },
    { year: "1994", value: 5 },
    { year: "1995", value: 4.9 },
    { year: "1996", value: 6 },
    { year: "1997", value: 7 },
    { year: "1998", value: 9 },
    { year: "1999", value: 13 },
  ];

  const config = {
    data,
    height: 400,
    xField: "year",
    yField: "value",
  };

  const config2 = {
    data: [
      { type: "opcion 1", value: 27 },
      { type: "opcion 2", value: 25 },
      { type: "opcion 3", value: 18 },
      { type: "opcion 4", value: 15 },
      { type: "opcion 5", value: 10 },
      { type: "opcion 6", value: 5 },
    ],
    angleField: "value",
    colorField: "type",
    label: {
      text: "value",
      style: {
        fontWeight: "bold",
      },
    },
    legend: {
      color: {
        title: false,
        position: "right",
        rowPadding: 5,
      },
    },
  };

  const data2 = [0.16, 0.125, 0.24, 0.19, 0.22, 0.05, 0.01, 0.015];

  const config3 = {
    data: data2.map((value) => ({
      index: value.toString(),
      value,
    })),
    xField: "index",
    yField: "value",
  };

  return (
    <>
     {/* <Segment textAlign="center" style={{
    borderRadius: "12px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
  }}>
        <Header as="h1">
          {t("WELCOME")} {useAuth().user.email}
        </Header>
      </Segment> */}
      {companySelected &&
      companySelected !== "0" &&
      companySelected !== 0 ? (
        // Empresa seleccionada → mostrar dashboard (con o sin sitio)
        <>
          <div className="tab-container">
          <Tab
            menu={{
              borderless: true,
              attached: false,
              tabular: false,
              style: {
                background: "transparent",
                boxShadow: "none",
                border: "none",
                padding: "0",
              },
              className: "custom-tab-menu"
            }}
            panes={panes}
            activeIndex={activeTab}
            onTabChange={(_, { activeIndex }) => setActiveTab(activeIndex)}
          />
          </div>
        </>
      ) : (
        // Sin empresa seleccionada → pedir que seleccionen empresa
        <div className="welcome-selector">
          <div className="welcome-selector__card">
            <h1 className="welcome-selector__title">BIENVENIDOS</h1>
            <p className="welcome-selector__subtitle">
              Seleccioná la empresa que querés consultar desde el menú superior.
            </p>
          </div>
        </div>
      )}
    </>
  );
}

